import {Component, OnDestroy, OnInit} from '@angular/core';
import {BookingV2StateService} from '../../services/booking-v2-state.service';
import {Subscription} from 'rxjs';
import {BookingStepsEnum} from '../../enums/booking-enums';

@Component({
  selector: 'app-stepper-header',
  templateUrl: './stepper-header.component.html',
  styleUrls: ['./stepper-header.component.scss'],
})
export class StepperHeaderComponent implements OnInit, OnDestroy {
  public header: string;
  private subscriptions: Subscription[] = [];

  constructor(
    private bookingState: BookingV2StateService,
  ) {
  }

  public ngOnInit(): void {
    this.setListeners();
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  private setHeaders(step: BookingStepsEnum): void {
    switch (step) {
      case BookingStepsEnum.SERVICES:
        this.header = 'Välj vårdtjänst';
        break;
      case BookingStepsEnum.CALENDAR:
        this.header = 'Välj tid';
        break;
      case BookingStepsEnum.SUBMIT:
        this.header = 'Slutför bokning';
        break;
    }
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.bookingState.state$.subscribe((result) =>
        this.setHeaders(result.step)
      )
    );
  }
}
